import React from 'react';
import LoginPage, { Username, Password, Submit, Title, Logo } from '@react-login-page/page6';

import { ReactComponent as MyLogo } from '../../LogoTools.svg';
import { wsurl,useWindowDimensions } from '../../CommonFunctions';

import { useState,useEffect } from 'react';
import { Snackbar } from "@mui/material";
import { Fragment } from "react";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const css = {
  '--login-bg': '#f3f2f2',
  '--login-color': '#333',
  '--login-logo': '#fff',
  '--login-inner-bg': '#fff',
  '--login-banner-bg': '#fbfbfb',
  '--login-input': '#333',
  '--login-input-icon': '#dddddd',
  '--login-input-bg': 'transparent',
  '--login-input-border': 'rgba(0, 0, 0, 0.13)',
  '--login-input-placeholder': '#999999',
  '--login-btn': '#fff',
  '--login-btn-bg': '#b08bf8',
  '--login-btn-bg-focus': '#b08bf8',
  '--login-btn-bg-hover': '#b08bf8',
  '--login-btn-bg-active': '#b08bf8',
};


const loginobj = {user:null,password:null};

const MyLoginPage = ({setToken})=>{

  const [snackbaropen, setOpen] = useState(false);
  const [message, setMessage] = useState();

  const { height, width } = useWindowDimensions();
  const styles = { height: height };

   useEffect( ()=>{
      if(message!==undefined){
        setOpen(true);
        console.log("open snackbar");
      }
    },[message])

  const setUser = (e)=>{
    loginobj.user = e.target.value;
  }
  const setPasswd = (e)=>{
    loginobj.password = e.target.value;
  }
  
  const getToken = ()=>{
    console.log("set token");
    fetch(wsurl+"/authtoken",{
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body: JSON.stringify(loginobj)  
    }).then((response)=> {
      if(response.status===404){
        console.log("user not found");
        setMessage("Utente non presente");
      } 
      else {
        return response.json();
      }
    })
      .then((tkn)=>{
        if(tkn!==undefined){
          console.log(tkn);
          setToken(tkn.token);
        }
      })
    .catch((error)=>{
      console.log("error "+error);
      setMessage("Errore "+error);
    });
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
          return;
    }
    setOpen(false);
    setMessage(undefined);
  };
 
  
      
  const snakbaraction = (
    <Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
      <div style={styles}>
        <Snackbar id="loginsb"
          open={snackbaropen}
          autoHideDuration={6000}
          onClose={handleClose}
          message={message}
          action={snakbaraction}
        />
        <LoginPage>
          <Username label="Utente" name="userUserName" onChange={setUser} />
          <Password label="Password" placeholder="password" name="userPassword" onChange={setPasswd} />
          <Submit onClick={getToken}>Accedi</Submit>
          <Title>AttrezzApp</Title>
          <Logo>
            <MyLogo width={45} height={45}/>          
          </Logo>
        </LoginPage>
      </div>
    );
}  
/*
<Logo>
            <LoginLogo />
          </Logo>*/
export default MyLoginPage;
